import { handleError, toastError } from "../funciones";
import axios from '../axiosConfig';
import { useEffect, useState, useCallback } from "react";

export const useAxiosGet = (url, params = {}, options = {}) => {
    const { enabled = true } = options;

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(enabled);

    const fetchData = () => {
        if (!enabled) return;

        setLoading(true);

        axios
            .get(process.env.REACT_APP_URL + url, { params })
            .then((res) => {
                setData(res.data);
            })
            .catch((error) => {
                toastError(handleError(error));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [url, JSON.stringify(params), enabled]);

    return { data, setData, loading, refetch: fetchData };
};
